<script setup lang="ts">
defineOptions({
  name: 'GlobalFooter'
});
</script>

<template>
  <DarkModeContainer class="h-full flex-center">
    <!-- <a href="https://github.com/soybeanjs/soybean-admin/blob/main/LICENSE" target="_blank" rel="noopener noreferrer"> -->
    Copyright © 2024 无锡酷研信息技术有限公司
    <!-- </a> -->
  </DarkModeContainer>
</template>

<style scoped></style>
